var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var AbstractPadstackData = require("./abstractPadstackData.js");

var fabSettings = require("./../circuit/pcb/fabSettings.js");
var defaultAOR = fabSettings.oshPark.OAR;

var PthPadstackData = function (topCopper, bottomCopper, hole, maskEnable, maskOverride, maskExpansion, connectionType) {
    var self = this;

    AbstractPadstackData.call(this, topCopper, maskEnable, maskOverride, maskExpansion, connectionType);

    this.hole = this.value("hole", true);

    this.innerCopper = this.cachedFunction("innerCopper", function () {
            var shape = self.hole().shape().clone();
            var expansion = defaultAOR;
            shape.width(shape.width()+expansion);
            shape.height(shape.height()+expansion);
            if(shape.rx) shape.rx(shape.rx()+expansion/2);
            if(shape.ry) shape.ry(shape.ry()+expansion/2);
            shape.rotate(self.hole().angle());
            shape.move(self.hole().pos());
            return shape;
        },
        [[this.hole, this.hole.onBubble]]
    );
    this.bottomCopper = this.value("bottomCopper", true);
    this.bottomSolderMask = this.topSolderMask;

    if(bottomCopper != undefined) this.bottomCopper(bottomCopper)
    if(hole != undefined) this.hole(hole);
};
lib_core.inherit(PthPadstackData, AbstractPadstackData);
lib_core.JsonParser.registerClass(PthPadstackData, "PthPadstackData");

module.exports = PthPadstackData;
